import styled from 'styled-components'

export const IndicatorList = styled.div`
  display: flex;
  flex-direction: column;

  .indicator {
    display: flex;
    flex-direction: row;
    margin: 10px 0;
    align-content: center;

    .icon-wrapper {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    > p {
      margin: 0;
    }
  }
`
